import decodeJWT from './decodeJWT';

const getToken = ({ decoded = false } = {}) => {
  let token = window.location.hash.slice(1); // url#token
  let decodedToken = decodeJWT(token);

  if (decodedToken !== null) {
    localStorage.setItem('editor-token', token);
  } else {
    token = localStorage.getItem('editor-token');
    decodedToken = decodeJWT(token);
  }

  return decoded ? decodedToken : token;
};

export default getToken;
